// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0a791358","667":"e81bbe07"}[chunkId] + ".chunk.js";
};